import { render, staticRenderFns } from "./questionnaireList.vue?vue&type=template&id=3a89209f&scoped=true"
import script from "./questionnaireList.vue?vue&type=script&lang=js"
export * from "./questionnaireList.vue?vue&type=script&lang=js"
import style0 from "./questionnaireList.vue?vue&type=style&index=0&id=3a89209f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89209f",
  null
  
)

export default component.exports